import { ChangeDetectorRef, Component, ElementRef, EventEmitter, HostListener, Input, NgZone, OnInit, Output, Renderer2, ViewChild, inject } from '@angular/core';
import { purgePlotlyCharts } from '../../../../core/common/utils/plotly-cleanup.util';
import { ChatbotUiService } from '../../../../core/chatbot/chatbot-ui.service';
import { UserService } from '../../../../core/auth/_services/user.service';
import { OffcanvasOptions } from '../../../../core/_base/metronic';
import { MatOptionSelectionChange } from '@angular/material/core';
import { Observable, Subject } from 'rxjs';
import { FileBrowserService } from '../../../../core/file-browser/file-browser.service';
import { finalize } from 'rxjs/operators';
import { HttpEventType } from '@angular/common/http';
import { LayoutUtilsService } from '../../../../core/_base/crud';
import { environment } from '../../../../../environments/environment';
import * as Plotly from 'plotly.js/dist/plotly.js';
import { FONT_FAMILY } from '../../../../core/common/constants/styles.constants';
import { MatDialog } from '@angular/material/dialog';
import { ChatbotDialogComponent } from '../../../components/shared-components/chatbot-dialog/chatbot-dialog.component';
import { animate, style, transition, trigger } from '@angular/animations';
import { ActivatedRoute, Router } from '@angular/router';
import { ResponsiveViewService } from '../../../../core/configuration/_services/responsive-view.service';
import { ChatSharePopupComponent } from '../chat-share-popup/chat-share-popup.component';
import { appendCloudAccessTokenToUrl } from '../../../../utils/general-utils';


export interface GraphType {
  name: string;
  type: string;
}

interface UploadedFile {
  name: string;
  type: string;
  size: number;
  progress: number;
  uploadFailed: boolean;
  incompleteFile: boolean;
  url: string;
  displayedName: string;
  uniqueName?: string;
}

@Component({
  selector: 'kt-chatbot-ui',
  templateUrl: './chatbot-ui.component.html',
  styleUrls: ['./chatbot-ui.component.scss'],
  animations: [
    trigger('slideInOut', [
      transition(':enter', [
        style({ height: 0, opacity: 0, overflow: 'hidden' }),
        animate('200ms ease-out', style({ height: '*', opacity: 1 }))
      ]),
      transition(':leave', [
        style({ height: '*', opacity: 1, overflow: 'hidden' }),
        animate('200ms ease-in', style({ height: 0, opacity: 0 }))
      ])
    ])
  ]
})
export class ChatbotUIComponent implements OnInit {
  @Output() closeCanvas = new EventEmitter<boolean>();
  @Input() sidebarUI = 'false';
  showScrollIcon = false;
  chatHistory: { _id?: string, id?: number, text?: string; thoughts?: object, data?: any[], feedBack?: Object, isUser: boolean; time_taken?: string, responsesAnimated?: boolean, modelChange?: boolean; model_type?: string; nextAnimateIndex?: any, responseAnimating?: any, createdTime?: any, references?: any[]; graphData?: any[]; tagData?: { threshold: { lower: number, upper: number }, tagId: string }, type?: number , files?: UploadedFile[] }[] = [];
  feedBack: { openFeedbackBox: boolean, showTextarea: boolean, outlinedLikedIcon: boolean, outlinedDisLikedIcon: boolean, isReading: boolean, isCopied: boolean, showFeedBack: boolean, supportDoc: boolean }
  userMessage: string = '';
  responseCounter: number = 0;
  enableSendButton: Boolean = true;
  isMobileView: boolean = false;
  hideThinking = false;
  userName: string
  showChild: boolean = false;
  userId: string;
  isSharedChat: boolean = false;
  isDislikePopupOpen = false;
  readingChat: boolean = false;
  description: string = '';
  showTextarea: boolean = false;
  textLoading: boolean = false;
  fileCount: number = 0;
  chatbotOptions = [
    { id: 2, label: 'Private', value: 'UptimeAI LLM' },
    { id: 3, label: 'Inhouse GPT', value: 'Inhouse GPT' },
  ];
  selectedChatbot = this.chatbotOptions[0];
  isLLMModelSelected : boolean = true;
  thoughtMessage = "";
  acceptedFileTypes: string = ".doc,.docx,.pdf,.png,.jpg,.jepg,.dwg,.pptx,.csv,.xlsx,.xls,.bmp";
  isFileUploading: boolean;
  openFeedbackBox: boolean = false
  fileNames = [];
  showUpload = (environment.runtime.CLOUD_SERVICE_PROVIDER !== 'vm');
  chatbotFolderUrl = '';
  tempFileinfo;
  @ViewChild('fileInput') fileInput: ElementRef;
  @ViewChild('chatMessageContainer', { read: ElementRef }) chatMessageContainer: ElementRef;
  @ViewChild('chatbotBody') chatbotBody: ElementRef;
  @ViewChild('startButton', { static: true }) startButton: ElementRef;
  @ViewChild('userInput') userInput: ElementRef<HTMLTextAreaElement>;
  @ViewChild('inputbox') inputbox: ElementRef<HTMLTextAreaElement>;
  @ViewChild('hideBottomGap') hideBottomGap: ElementRef;
  @ViewChild('chatBody') chatBody: ElementRef;
  recognition: any;
  isRecording = false;
  isMessageSent = false;
  scrollable = false;
  isFocused = false;
  selectedFeedback: number = 0;
  hideReasoning = true;
  speechSupported: boolean = true;
  startTime;
  endTime;
  graphType: { [id: number]: GraphType } = {
    1: { name: 'Line Chart', type: 'scatter' },
    2: { name: 'Bar Chart', type: 'bar' },
    3: { name: 'Marker Chart', type: 'scatterg1' },
    5: { name: 'Area Chart', type: 'scatter' },
    19: { name: 'Box Chart', type: 'box' }
  }
  supportedLanguageList = [
    {
      name: 'English-US',
      value: 'en-US'
    },
    {
      name: 'Arabic',
      value: 'ar-AE'
    },
  ];
  selectedLanguage = this.supportedLanguageList[0];
  thinkingWorkers = new Map<string, Worker>();
  streamingRunMap = new Map<string, any>();
  responseWorkers = new Map<string, Worker>();

  uploadedFiles: UploadedFile[] = [];
  private fileTypeIcons = {
    'pdf': 'picture_as_pdf',
    'doc': 'description',
    'docx': 'description',
    'png': 'image',
    'jpg': 'image',
    'jpeg': 'image',
    'xls': 'table_chart',
    'xlsx': 'table_chart',
    'default': 'insert_drive_file',
  };

  fileIconBackgroundColors = {
    'pdf': '#EB5B6E',
    'doc': '#16970D',
    'docx': '#0D1EBE',
    'xls': '#16970D',
    'xlsx': '#16970D',
    'jpeg' : '#575757',
    'jpg': '#575757',
    'png': '#575757',
    'default': '#EAC210',
  };

  constructor(
    private readonly chatbotService: ChatbotUiService,
    private readonly userService: UserService,
    private readonly _changeDetectorRef: ChangeDetectorRef,
    private readonly renderer: Renderer2,
    private readonly fileBrowserService: FileBrowserService,
    private readonly layoutUtilsService: LayoutUtilsService,
    private readonly elRef: ElementRef,
    private readonly dialog: MatDialog,
    private readonly zone: NgZone,
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly responsiveViewService: ResponsiveViewService
  ) { }

  ngOnInit(): void {
    this.responsiveViewService.isMobileView$.subscribe(value => {
      this.isMobileView = value;
    });
    const runId = this.route.snapshot.queryParamMap.get('run_id');
    this.chatbotOptions = this.chatbotOptions.filter(option => environment.runtime.GENAI_MODEL_OPTIONS.includes(option.id));
    this.selectedChatbot = this.chatbotOptions[0];
    this.selectedChatbot.label == 'Inhouse GPT' ? this.isLLMModelSelected = false : this.isLLMModelSelected = true;
    if (runId) {
      this.isSharedChat = true;
      this.loadSharedChat(runId);
    }
    this.getUserDetails();
    this.initializeSpeechRecognition();
    this.chatbotService.createNewSessionId();
  }

  ngAfterViewInit(): void {
    this.checkScroll();
    this.checkScrollPosition();
    this.adjustWidth();
  }

  private readonly _plotlyHost = inject(ElementRef);

  ngOnDestroy(): void {
    purgePlotlyCharts(this._plotlyHost.nativeElement);
    this.chatbotService.deleteSession().subscribe({
      next: () => {
        console.log('Session deleted successfully');
      },
      error: (error) => {
        console.error('Error deleting session:', error);
      }
    });
  }

  animateWords(text: string) {
    this.thoughtMessage = '';
    const words = text.split(' ');
    let index = 0;
    const typingSpeed = 100;
    const intervalId = setInterval(() => {
      if (index < words.length) {
        this.thoughtMessage += words[index] + ' ';
        index++;
        this._changeDetectorRef.detectChanges();
      } else {
        clearInterval(intervalId);
      }
    }, typingSpeed);
  }

  initializeSpeechRecognition() {
    const { webkitSpeechRecognition } = window as any;
    let speechRecognition = webkitSpeechRecognition || (window as any).SpeechRecognition || (window as any).mozSpeechRecognition || (window as any).msSpeechRecognition;
    if (!speechRecognition) {
      this.speechSupported = false;
      return;
    }
    this.recognition = new speechRecognition();
    this.speechSupported = true;
    this.recognition.lang = this.selectedLanguage.value;
    this.recognition.interimResults = true; // Enable interim results to handle pauses
    this.recognition.continuous = true; // Keep recognition running after pauses
    this.recognition.maxAlternatives = 1;

    this.recognition.onstart = () => {
      this.isRecording = true;
      this.isMessageSent = false;
    };

    this.recognition.onresult = (event: any) => {
      let interim_transcript = '';
      let finalResult = '';
      for (let i = event.resultIndex; i < event.results.length; ++i) {
        if (event.results[i].isFinal) {
          finalResult += event.results[i][0].transcript;
          this.animateText(finalResult);
        } else {
          interim_transcript += event.results[i][0].transcript;
        }
      }

      this._changeDetectorRef.detectChanges();
    };

    this.recognition.onend = () => {
      this.isRecording = false;
    };

  }

  selectLanguage(index: number) {
    this.userMessage = '';
    this.selectedLanguage = this.supportedLanguageList[index];
    if (this.speechSupported) this.recognition.lang = this.selectedLanguage.value;
    this.isRecording = false;
    this.stopRecognition();
  }

  selectFeedback(chatId: number, value: number): void {
    let feedBack = this.chatHistory[chatId - 1]?.feedBack;
    this.selectedFeedback = value;
    this.description = null;
    switch (value) {
      case 1:
        this.description = "Not factually correct";
        break;
      case 2:
        this.description = "Didn't fully follow instructions";
        break;
      default:
        feedBack['showTextarea'] = true;
        break;
    }
    if (value != 3) {
      this.chatbotService.sendFeedback(this.chatHistory[chatId - 1]._id, 0, this.description).subscribe();
      feedBack['openFeedbackBox'] = false;
      this.isDislikePopupOpen = false;
    }
    this.chatHistory[chatId - 1].feedBack = feedBack;
  }

  cancelFeedback(chatId): void {
    let feedBack = this.chatHistory[chatId - 1]?.feedBack;
    feedBack['showTextarea'] = false;
    this.selectedFeedback = null;
    this.description = null;
    this.chatHistory[chatId - 1].feedBack = feedBack;
  }

  closeFeedback(chatId) {
    let feedBack = this.chatHistory[chatId - 1]?.feedBack;
    feedBack['openFeedbackBox'] = false;
    feedBack['outlinedDisLikedIcon'] = true;
    feedBack['showTextarea'] = false;
    this.description = null;
    this.selectedFeedback = null;
    this.chatHistory[chatId - 1].feedBack = feedBack;
    this.isDislikePopupOpen = false;
  }

  submitFeedback(chatId): void {
    let feedBack = this.chatHistory[chatId - 1]?.feedBack;
    this.chatbotService.sendFeedback(this.chatHistory[chatId - 1]._id, 0, this.description).subscribe(() => {
      feedBack['openFeedbackBox'] = false;
      feedBack['showTextarea'] = false;
      this.chatHistory[chatId - 1].feedBack = feedBack;
      this.selectedFeedback = null;
      this.layoutUtilsService.showActionNotification(`Thanks for your feedback!`);
      this._changeDetectorRef.detectChanges();
    })
    this.isDislikePopupOpen = false;
  }

  toggleRecognition() {
    if (!this.speechSupported) return;
    if (!this.isRecording) {
      this.startRecognition();
      this.scrollable = false;
      this.showScrollIcon = false;
    }
    else {
      this.stopRecognition();
      this.checkScrollPosition();
      this.checkScroll();
    }
    this.isRecording = !this.isRecording;
  }

  startRecognition() {
    if (!this.speechSupported) return;
    this.recognition.start();
  }

  stopRecognition() {
    if (!this.speechSupported) return;
    this.recognition.stop();
  }

  animateText(text: string) {
    // this.userMessage = '';
    let index = 0;
    const typingSpeed = 100;
    const textArr = text.split(' ');
    const intervalId = setInterval(() => {
      if (index < textArr.length) {
        this.userMessage += textArr[index] + ' ';
        this.adjustHeight();
        this.userInput.nativeElement.scrollTop = this.userInput?.nativeElement?.scrollHeight;
        index++;
        this._changeDetectorRef.detectChanges();
      } else {
        clearInterval(intervalId);
      }
    }, typingSpeed);
  }

  getUniqueReferences(data, key) {
    let distinctMap = {};
    data.forEach(item => {
      if (!distinctMap[item[key]]) {
        distinctMap[item[key]] = item;
      }
    });
    return Object.values(distinctMap);
  }

  openInNewTab() {
    window.open('/web/genai', '_blank');
  }

  getUserDetails() {
    const userDetails = this.userService.getUserFromLocalStorage();
    this.userName = userDetails.name;
    this.userId = userDetails._id;
    this.chatbotFolderUrl = userDetails.facility?.[0] ? userDetails.facility[0] + '/' : '';
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event): void {
    this.adjustWidth();
  }

  adjustWidth(): void {
    if (this.inputbox && this.inputbox.nativeElement.parentElement) {
      const parentWidth = this.inputbox.nativeElement.parentElement.offsetWidth;
      if (!parentWidth) {
        return;
      }
      this.renderer.setStyle(this.inputbox.nativeElement, 'width', `${parentWidth * 100.5 / 100}px`);
      this.renderer.setStyle(this.hideBottomGap.nativeElement, 'width', `${parentWidth * 105 / 100}px`);
    }
  }

  scrollToBottom(): void {
    if (this.sidebarUI == 'true') {
      this.checkScroll();
      const element = this.chatMessageContainer?.nativeElement;
      element.scrollTo({ top: element.scrollHeight, behavior: 'smooth' });
    }
    else {
      this.checkScrollPosition();
      const element = this.chatbotBody?.nativeElement;
      element.scrollTo({ top: element.scrollHeight, behavior: 'smooth' });
    }
  }

  checkScroll() {
    if (this.isRecording) return;
    const el = this.chatMessageContainer?.nativeElement;
    const atBottom = el?.scrollHeight - el?.scrollTop - 1 > el?.clientHeight;
    this.scrollable = atBottom;
  }

  checkScrollPosition(): void {
    if (this.isRecording) return;
    const el = this.chatbotBody?.nativeElement;
    const atBottom = el?.scrollHeight - el?.scrollTop - 1 > el?.clientHeight;
    this.scrollable = atBottom;
    this._changeDetectorRef.detectChanges();
  }

  toggleChatbot(event: MatOptionSelectionChange) {
    const selectedValue = event.source.value.value;
    if (selectedValue === 'UptimeAI LLM' || selectedValue === 'UptimeAI GPT') {
      this.isLLMModelSelected = true;
    }
    else {
      this.isLLMModelSelected = false;
    }
    this.chatbotService.chatbotText = '';
    this.responseCounter++;
    this.chatHistory.push({ id: this.responseCounter, text: `Switched to '${selectedValue}'`, isUser: false, modelChange: true })
    this._changeDetectorRef.detectChanges();
    this.scrollToBottom()
  }

  isUserMessage() {
    return !this.userMessage?.trim().length;
  }

  getBotResponse() {
    this.isMessageSent = true;
    this.isRecording = false;
    this.enableSendButton = false;
    this.hideThinking = false;
    this.showChild = false;
    this.recognition?.stop();
    if (this.chatbotService.chatbotText !== '') {
      this.enableSendButton = true;
      let prompts = [`Why does ${this.chatbotService.chatbotText} happens on ${this.chatbotService.systemName}?`, `How to fix it?`];
      this.chatbotService.chatbotText = '';
      this.getBotResponseForMultiplePrompts(prompts, 0);
    }
    else {
      if (this.userMessage.trim() === '') {
        this.enableSendButton = true;
        return;
      }
      const message = this.userMessage.trim();
      this.userMessage = '';
      this.responseCounter++;
      const createdTime = this.setUpdatedTime();
      this.chatHistory.push({ id: this.responseCounter, text: message, isUser: true, createdTime: createdTime, files: this.uploadedFiles });
      this.textLoading = true;
      this._changeDetectorRef.detectChanges();
      if (this.responseCounter > 1) {
        this.scrollToBottom();
        this.removeDisliked();
      }
      if (this.uploadedFiles.length > 0) {
        this.uploadedFiles = [];
        this.fileCount = 0;
      }
      this.resetHeight();
      this.startTime = new Date().getTime();
      this.fetchBotResponse(message, environment.runtime.GENAI_STREAMING_ENABLED).subscribe({
        next: (response) => {
          this.endTime = new Date().getTime();
          if (environment.runtime.GENAI_STREAMING_ENABLED && (response['type'] === 'thinking' || response['type'] === 'answer')) {
            this.makeFormattedResponse(response);
          } else if (typeof response['data'] === 'object' && response['status'] === 'success' && response['data'][0]?.hasOwnProperty('type')) {
            this.makeFormattedResponse(response);
          } else if (environment.runtime.GENAI_STREAMING_ENABLED && response['type']) {
            if (response['type'] === 'error') {
              console.error('Error chunk received from streaming API:', response);
            }
            return;
          } else if ((typeof response['data'] === 'object' && response['data'].status !== 200) || response['status'] !== 200) {
            const runId = response['run_id'];
            let chatEntry = this.streamingRunMap.get(runId);
            if (chatEntry) {
              this.chatHistory[chatEntry.id - 1] = { id: this.responseCounter, text: 'Not able receive a response from an upstream server. Please try again or contact support.', isUser: false }
            }
            else {
              this.responseCounter++;
              this.chatHistory.push({ id: this.responseCounter, text: 'Something went wrong! An unexpected error has occurred. Please try again later.', isUser: false });
            }
            this.enableSendButton = true;
          } else {
            let text = '';
            if (response['model_type'] === 'FUNC' && typeof response['answer'] === 'object') {
              text = response['answer']['graphData']?.length === 0 ? 'No Data Found.' : `Chart for ${response['answer']['tagData']['tagId']}`;
            } else {
              text = response['answer'] || 'No response received.';
            }
            this.responseCounter++;
            this.chatHistory.push({ id: this.responseCounter, text: text, isUser: false, model_type: response['model_type'], references: this.getUniqueReferences(response['references'], 'source'), graphData: response['answer']['graphData'], tagData: response['answer']['tagData'], type: response['answer']['type'] });
          }
          this.updateResponse(this.responseCounter);
          if (this.chatHistory[this.chatHistory.length - 1]?.graphData) {
            this.plotGraph(this.chatHistory.length - 1);
          }
          this.scrollToBottom();
          this.textLoading = false;
        },
        error: (error) => {
          if (error.status == 401) {
            // Redirect to login page if authentication fails
            this.router.navigate(['/web/login'], { queryParams: { returnUrl: window.location.pathname } });
            return;
          }
          const errorMessage = 'Something went wrong! An unexpected error has occurred. Please try again later.';
          this.responseCounter++;
          this.chatHistory.push({ id: this.responseCounter, text: errorMessage, isUser: false, });
          this.enableSendButton = true;
          this.textLoading = false;
        },
        complete: () => {
          this.textLoading = false;
          this._changeDetectorRef.detectChanges();
        },
      });
    }
  }

  calculateDuration(): any {
    if (!this.startTime || !this.endTime) return 0;
    const durationMs = this.endTime - this.startTime;
    const durationSeconds = durationMs / 1000;
    return parseFloat(durationSeconds.toFixed(2));
  }

  makeFormattedResponse(response: any) {
    if (!response) return;
    // Non-streaming full response
    if (response.status && Array.isArray(response.data)) {
      const runId = response.run_id;
      let chatEntry = this.streamingRunMap.get(runId);
      response.data.forEach(item => {
        if (!chatEntry) {
          const initialThought = item.type === 'thinking' ? item.data.data : '';
          const initialAnswer = item.type === 'answer' ? [{ ...item.data, animate: true }] : [];

          chatEntry = {
            _id: runId,
            id: ++this.responseCounter,
            time_taken: response.time_taken,
            thoughts: {
              show: true,
              text: initialThought,
              animatedText: '',
              animated: false,
              animating: false
            },
            data: initialAnswer,
            nextAnimateIndex: 0,
            responseAnimating: false,
            isUser: false,
            responsesAnimated: false
          };

          this.chatHistory.push(chatEntry);
          this.streamingRunMap.set(runId, chatEntry);

          if (chatEntry.thoughts['show'] && !chatEntry.thoughts['animated'] && chatEntry.thoughts['text'] && chatEntry.thoughts['text'].length > 0) {
            this.animateChatText(chatEntry, () => {
              this.animateResponse(chatEntry);
            });
          } else {
            this.animateResponse(chatEntry);
          }
        }
        else {
          if (item.type === 'thinking') {
            chatEntry.thoughts['text'] += (chatEntry.thoughts['text'] ? '<br>' : '') + item.data.data;
          } else if (item.type === 'answer') {
            if (!chatEntry.data.length && !chatEntry.thoughts['text']?.length) {
              chatEntry.data.push({ ...item.data, animate: true });
              chatEntry.responsesAnimated = true;
              this.animateTextResponses(chatEntry);
            }
            else {
              if (chatEntry.data.length && chatEntry.data[chatEntry.data.length - 1].metadata?.length) {
                chatEntry.data.push({ animatedData: '***', data: '***', animate: false, type: 'text' });
              }
              chatEntry.data.push({ ...item.data, animate: true });
              // Start animation if thoughts already finished
              if (!chatEntry.responseAnimating && chatEntry.thoughts.animated) {
                this.animateTextResponses(chatEntry);
              }
            }
          }
        }
      });
    }

    // Streaming (chunked) response
    else if (response.run_id) {
      const runId = response.run_id;
      let chatEntry = this.chatHistory.find(entry => entry._id === runId);

      if (!chatEntry) {
        chatEntry = {
          _id: runId,
          id: ++this.responseCounter,
          time_taken: this.calculateDuration(),
          thoughts: {
            show: true,
            text: '',
            animatedText: '',
            animated: false,
            animating: false
          },
          data: [],
          nextAnimateIndex: 0,
          responseAnimating: false,
          isUser: false,
          responsesAnimated: false
        };
        this.chatHistory.push(chatEntry);
      }

      if (response.type === 'thinking') {
        const newText = response.data?.data ?? '';
        if (newText) {
          chatEntry.thoughts['text'] += chatEntry.thoughts['text'] ? '<br>' + newText : newText;
          chatEntry.thoughts['animated'] = false;
          if (!chatEntry.thoughts['animating']) {
            this.animateChatText(chatEntry, () => {
              this.endTime = new Date().getTime();
              chatEntry.time_taken = this.calculateDuration();
              chatEntry.responsesAnimated = true;
              this.animateTextResponses(chatEntry);
            });
          }
        }
      } else if (response.type === 'answer') {
        const newAnswer = response.data;
        if (!chatEntry.data.length && !chatEntry.thoughts['text']?.length) {
          chatEntry.data.push({ ...newAnswer, animate: true });
          chatEntry.responsesAnimated = true;
          this.animateTextResponses(chatEntry);
        } else {
          if (chatEntry.data.length && chatEntry.data[chatEntry.data.length - 1].metadata?.length) {
            chatEntry.data.push({ animatedData: '***', data: '***', animate: false, type: 'text' });
          }

          chatEntry.data.push({ ...newAnswer, animate: true });

          // Start animation if thoughts are already done
          if (!chatEntry.responseAnimating && chatEntry.thoughts['animated']) {
            this.animateTextResponses(chatEntry);
          }
        }
      }
    }
  }

  animateChatText(chatEntry: any, callback?: Function): void {
    const runId = chatEntry._id;
    if (chatEntry.thoughts.animating) return;

    chatEntry.thoughts.animating = true;
    let worker = this.thinkingWorkers.get(runId);
    if (!worker) {
      worker = new Worker(new URL('./typing.worker', import.meta.url), { type: 'module' });
      this.thinkingWorkers.set(runId, worker);

      worker.onmessage = ({ data }) => {
        if (data.char) {
          this.zone.run(() => {
            chatEntry.thoughts.animatedText += data.char;
            this._changeDetectorRef.detectChanges();
          });
        } else if (data.done) {
          chatEntry.thoughts.animating = false;

          if (chatEntry.thoughts.animatedText.length < chatEntry.thoughts.text.length) {
            this.animateChatText(chatEntry, callback);
          } else {
            chatEntry.thoughts.animated = true;
            chatEntry.responsesAnimated = true;
            const w = this.thinkingWorkers.get(runId);
            if (w) w.terminate();
            this.thinkingWorkers.delete(runId);
            this.streamingRunMap.delete(runId);

            if (callback) this.zone.run(() => callback());
          }
        }
      };
    }

    const startFrom = chatEntry.thoughts.animatedText.length;
    worker.postMessage({
      text: chatEntry.thoughts.text,
      speed: 5,
      start: startFrom
    });
  }

  async animateTextResponses(chatEntry: any): Promise<void> {
    const runId = chatEntry._id;

    if (chatEntry.responseAnimating) return; // avoid duplicate calls
    chatEntry.responseAnimating = true;
    chatEntry.thoughts['show'] = false;
    const animateNext = async () => {
      // Skip already animated or un-animatable items
      while (
        chatEntry.nextAnimateIndex < chatEntry.data.length &&
        (!chatEntry.data[chatEntry.nextAnimateIndex].animate || chatEntry.data[chatEntry.nextAnimateIndex].type !== 'text')
      ) {
        const item = chatEntry.data[chatEntry.nextAnimateIndex];

        if (item.type === 'table' || item.type === 'plotly') {
          this.zone.run(() => {
            this.showChild = true;
            this._changeDetectorRef.detectChanges();
          });
        }
        chatEntry.nextAnimateIndex++;
      }

      if (chatEntry.nextAnimateIndex >= chatEntry.data.length) {
        // Done animating all
        chatEntry.responseAnimating = false;
        this.zone.run(() => {
          this.enableSendButton = true;
          if (this.chatHistory[chatEntry.id - 1]?.feedBack && this.chatbotService.streamingComplete) {
            this.chatHistory[chatEntry.id - 1].feedBack['showSupportDoc'] = true;
            this.chatHistory[chatEntry.id - 1].feedBack['showFeedBack'] = true;
          }
          this._changeDetectorRef.detectChanges();
        });
        return;
      }

      const resp = chatEntry.data[chatEntry.nextAnimateIndex];

      if (resp.type === 'text') {
        resp.animatedData = '';
        const startFrom = resp.animatedData.length;
        const worker = new Worker(new URL('./typing.worker', import.meta.url), { type: 'module' });
        this.responseWorkers.set(runId, worker);

        worker.onmessage = ({ data }) => {
          if (data.char) {
            this.zone.run(() => {
              resp.animatedData += data.char;
              this._changeDetectorRef.detectChanges();
            });
          } else if (data.done) {
            worker.terminate();
            this.responseWorkers.delete(runId);
            chatEntry.nextAnimateIndex++;
            animateNext();
          }
        };

        worker.postMessage({
          text: resp.data,
          speed: 5,
          start: startFrom
        });
      }
    };

    // Start animation sequence
    await animateNext();
  }

  // Initialised Feedback Object
  updateResponse(id: number) {
    let feeBack = {
      feedback: 0,
      isReading: false,
      isCopied: false,
      description: '',
      openFeedbackBox: false,
      showTextarea: false,
      outlinedLikedIcon: true,
      outlinedDisLikedIcon: true,
      showSupportDoc: false,
      showFeedBack: this.hideThinking ? true : false,
    }
    this.chatHistory[id - 1]['feedBack'] = feeBack;
  }

  getImageLink(data: string): string {
    return "data:image/png;base64," + data;
  }

  getBotResponseForMultiplePrompts(prompts: string[], index: number) {
    if (prompts && prompts.length && index < prompts.length) {
      this.hideThinking = true;
      let prompt = prompts[index];
      this.responseCounter = this.responseCounter + 1;
      this.chatHistory.push({ id: this.responseCounter, text: prompt, isUser: true })
      this.textLoading = true;
      this._changeDetectorRef.detectChanges();
      this.scrollToBottom()
      this.fetchBotResponse(prompt, false).subscribe({
        next: (response) => {
          if (typeof response['data'] === 'object' && response['status'] === 'success' && response['data'][0]?.hasOwnProperty('type')) {
            this.responseCounter++;
            this.chatHistory.push({ _id: response['run_id'], id: this.responseCounter, data: [{ ...response['data[0]'].data, animate: false }], isUser: false, responsesAnimated: true });
          }
          else {
            this.responseCounter++;
            this.chatHistory.push({ id: this.responseCounter, text: 'Something went wrong! An unexpected error has occurred. Please try again later.', isUser: false });
          }
        },
        error: (error) => {
          const errorMessage = error.error?.message || 'Something went wrong! An unexpected error has occurred. Please try again later.';
          this.responseCounter++;
          this.chatHistory.push({ id: this.responseCounter, text: errorMessage, isUser: false, });
        },
        complete: () => {
          this.textLoading = false;
          this.enableSendButton = true;
          this.updateResponse(this.responseCounter);
          this.getBotResponseForMultiplePrompts(prompts, ++index);
          this._changeDetectorRef.detectChanges();
          this.scrollToBottom()
        },
      });
    }
  }

  loadSharedChat(runId: string) {
    this.chatbotService.getSharedChat(runId).subscribe({
      next: (response) => {
        if (response['status'] === 200 && response['data']) {
          this.responseCounter = 1;
          this.chatHistory.push({ id: this.responseCounter, text: response['data'].query, isUser: true, createdTime: response['data'].createdTime });
          const responseObject = JSON.parse(response['data'].response);
          let thinking = '';
          let answer = [];
          responseObject.data.forEach((data: any) => {
            if (data.type === 'thinking') {
              thinking += (thinking ? '<br>' : '') + data.data.data;
            } else if (data.type === 'answer') {
              answer.push({ ...data.data, animate: false });
            }
          });
          let chatEntry = {
            _id: responseObject.run_id,
            id: ++this.responseCounter,
            time_taken: responseObject.time_taken,
            thoughts: {
              show: false,
              text: thinking,
              animatedText: thinking,
              animated: true,
              animating: false
            },
            data: answer,
            responseAnimating: false,
            isUser: false,
            responsesAnimated: true,
            feedBack: {
              showSupportDoc: false
            }
          };
          this.chatHistory.push(chatEntry);
          this.showChild = true; // Show table/graph for shared chat rendering
          this.chatHistory[this.responseCounter - 1]['feedBack']['showSupportDoc'] = true; // Show support doc for shared chat rendering
          this._changeDetectorRef.detectChanges();
        }
      }
    });
  }

  animateResponse(chatEntry: any) {
    chatEntry.responsesAnimated = true;
    this.animateTextResponses(chatEntry);
  }

  plotGraph(index) {
    let ids = `chatbot-${index}`
    let graphData = this.chatHistory[index]?.graphData;
    let valueX = graphData.map(item => new Date(item?.t))
    let valueY = graphData.map(item => item?.a)
    const trace = [
      {
        name: this.chatHistory[index].tagData.tagId || 'Tag Name',
        x: valueX,
        y: valueY,
        type: this.graphType[this.chatHistory[index].type || 1].type,
        line: { color: '#db3f52', width: 1 }
      }
    ]
    if (this.chatHistory[index].tagData.threshold.lower) {
      const obj = {
        name: "Lower Bound",
        x: [valueX[0], valueX[valueX.length - 1]],
        y: [this.chatHistory[index].tagData?.threshold.lower, this.chatHistory[index].tagData?.threshold.lower],
        type: 'scatter',
        mode: 'lines',
        line: { dash: 'dash', color: 'black', width: 1 }
      }
      trace.push(obj)
    }
    if (this.chatHistory[index].tagData.threshold.upper) {
      const obj = {
        name: "Upper Bound",
        x: [valueX[0], valueX[valueX.length - 1]],
        y: [this.chatHistory[index].tagData?.threshold.upper, this.chatHistory[index].tagData?.threshold.upper],
        type: 'scatter',
        mode: 'lines',
        line: { color: 'black', width: 1 }
      }
      trace.push(obj)
    }

    if (this.chatHistory[index].type == 5) trace[0]['fill'] = "tozeroy"
    else if (this.chatHistory[index].type == 3) {
      trace[0]['mode'] = 'markers'
      trace[0]['marker'] = { size: 3 }
    }

    const layout = {
      // title: this.graphType[this.chatHistory[index].type || 1].name,
      xaxis: {
        // title: 'createdTime',
      },
      yaxis: {
        // title: 'Y Axis',
        automargin: true
      },
      margin: {
        l: 30,
        r: 30,
        t: 30,
        b: 40
      },
      legend: {
        x: 0,
        y: -0.2,
        orientation: 'h'
      },
      showlegend: true,
      font: {
        ...FONT_FAMILY,
        size: 10,
        color: '#000'
      },
      // hoverlabel.font does NOT inherit from layout.font (except unified hovermode); set family.
      hoverlabel: { font: { family: FONT_FAMILY.family } }
    };

    let div = document.getElementById(ids)
    if (div) {
      Plotly.newPlot(div, trace, layout, { responsive: true, displaylogo: false });
    }
  }

  fetchBotResponse(message: string, streamingEnabled?: boolean): Observable<Object> {
    if (this.isLLMModelSelected) {
      if (!this.chatbotService.sessionId) {
        this.chatbotService.createNewSessionId();
      }
      const body = {
        query: message,
        user_id: this.userId,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        metadata: {},
      };
      return this.chatbotService.getInhouseChatbotResponse(
        message,
        streamingEnabled,
        (new Date()).toISOString(),
        'POST',
        body
      );
    }
    else {
      return this.chatbotService.getChatbotResponse(this.userId, message);
    };
  }

  close() {
    // send event to parent component
    this.closeCanvas.emit();
  }

  handleFileUpload(event: any) {
    if (!this.chatbotFolderUrl) return;

    const files: FileList = event.target.files;
    if (!files || files.length === 0) return;
    const fileArray = Array.from(files);
    const validFiles = fileArray.filter(file => this.validateFile(file));
    this.fileCount = this.fileCount + validFiles.length;
    this.adjustHeight();

    if (validFiles.length === 0) {
      this.layoutUtilsService.showActionNotification('No valid files selected. Only files with extensions ' + this.acceptedFileTypes + ' are allowed');
      return;
    }

    validFiles.forEach(file => this.processFileUpload(file));
    this.fileInput.nativeElement.value = '';
  }


  validateFile(file: File): boolean {
    const fileExtension = file.name.split('.').pop()?.toLowerCase();

    if (!this.acceptedFileTypes.includes(fileExtension)) {
      this.layoutUtilsService.showActionNotification(`File "${file.name}" not allowed. Only files with extensions ${this.acceptedFileTypes} are allowed.`);
      return false;
    }
    return true;
  }

  processFileUpload(file: File) {
    const uniqueName = this.getUniqueFileName(file.name);
    const newFileObject: UploadedFile = {
      displayedName: file.name.length > 18 ? file.name.substring(0, 18) + '...' : file.name,
      type: file.type,
      size: file.size,
      progress: 0,
      uploadFailed: false,
      incompleteFile: true,
      name: file.name,
      url: '',
      uniqueName: uniqueName
    };

    // Add to uploaded files array
    this.uploadedFiles.push(newFileObject);
    this.isFileUploading = true;
    this._changeDetectorRef.detectChanges();

    // Start upload
    this.fileBrowserService.uploadFile(file, uniqueName, this.chatbotFolderUrl).pipe(
      finalize(() => {
        const hasIncompleteUploads = this.uploadedFiles.some(file => file.incompleteFile);
        this.isFileUploading = hasIncompleteUploads;
        if(!this.isFileUploading){
            this.fileUpload();
        }
      })
    ).subscribe({
      next: (event) => {
        if (event.type === HttpEventType.UploadProgress) {
          const percentDone = Math.round((100 * event.loaded) / event.total);
          newFileObject.progress = percentDone;
          this._changeDetectorRef.detectChanges();
        }
        else if (event.type === HttpEventType.Response) {
          newFileObject.progress = 100;
          newFileObject.incompleteFile = false;
          this.fileNames.push(newFileObject.uniqueName);
          newFileObject.url = appendCloudAccessTokenToUrl(event.fileUrl);
        }
      },
      error: (error) => {
        this.handleUploadError(error, newFileObject, file);
      }
    });
  }

  fileUpload() {
    this.chatbotService.uploadFiles(this.uploadedFiles, true)
      .subscribe({
        next: (res) => {
          if (res['status'] == 'success') {
            this.layoutUtilsService.showActionNotification(`${res['message']}`);
          } else {
            this.layoutUtilsService.showActionNotification('Files failed to upload.');
            this.uploadedFiles = [];
            this.fileCount = 0;
            this.resetHeight();
          }
        },
        error: (err) => {
          this.layoutUtilsService.showActionNotification('Files failed to upload.');
          this.uploadedFiles = [];
          this.fileCount = 0;
          this.resetHeight();
        }
      });
  }

  handleUploadError(error: any, fileObject: UploadedFile, file: File) {
    fileObject.uploadFailed = true;
    fileObject.incompleteFile = false;

    if (error.status === 413) {
      this.layoutUtilsService.showActionNotification(
        `${file.name} failed to upload due to file size limit.`
      );
    } else {
      this.layoutUtilsService.showActionNotification(
        `${file.name} failed to upload.`
      );
    }
    this._changeDetectorRef.detectChanges();
  }

  removeFile(index: number) {
    const file = this.uploadedFiles[index];
    if (file.uniqueName && this.fileNames.includes(file.uniqueName)) {
      const nameIndex = this.fileNames.indexOf(file.uniqueName);
      if (nameIndex > -1) {
        this.fileNames.splice(nameIndex, 1);
      }
    }
    this.uploadedFiles.splice(index, 1);
    this.fileCount--;
    this.adjustHeight();
    this._changeDetectorRef.detectChanges();
    // Later to be implemented: Remove file from server
    // this.deleteFileFromServer(file);
  }

  getUniqueFileName(fileName: string): string {
    let fileNames = this.fileNames.concat(this.uploadedFiles.map(f => f.uniqueName || f.name));
    let name = fileName;
    let ext = '';
    const dotIndex = fileName.lastIndexOf('.');

    if (dotIndex > -1) {
      name = fileName.substring(0, dotIndex);
      ext = fileName.substring(dotIndex);
    }

    let newFileName = fileName;
    let counter = 1;

    while (fileNames.includes(newFileName)) {
      newFileName = `${name}(${counter})${ext}`;
      counter++;
    }

    return newFileName;
  }

  getFileIcon(file: UploadedFile): string {
    let extension = '';
    if (file.name && file.name.includes('.')) {
      extension = file.name.split('.').pop()?.toLowerCase() || '';
    }
    return this.fileTypeIcons[extension] || this.fileTypeIcons['default'];
  }

  getBackgroundColor(file: UploadedFile) {
    let extension = '';
  if (file.name && file.name.includes('.')) {
    extension = file.name.split('.').pop()?.toLowerCase() || '';
  }
  return this.fileIconBackgroundColors[extension] || this.fileIconBackgroundColors['default'];
  }

  getChatbotFolderItems() {
    if (!this.chatbotFolderUrl) return;
    this.fileBrowserService.getFilesAndFolders(this.chatbotFolderUrl).subscribe(res => {
      if (res.status === 200) {
        const data = res.data;
        const fileNames = [];
        for (const key in data) {
          if (data[key].type === 'file') {
            const fileName = key.split('/').pop();
            fileNames.push(fileName);
          }
        }
        this.fileNames = fileNames;
      }
    });
  }
  adjustHeight() {
    const textarea = this.userInput.nativeElement;
    const inputarea = this.inputbox.nativeElement;
    textarea.style.height = '50px'; // Reset height to auto
    inputarea.style.height = '120px';
    textarea.style.height = `${Math.max(textarea.scrollHeight, 50)}px`;
    let inputBoxHeight = Math.max(textarea.scrollHeight+67,120);
    inputBoxHeight = this.sidebarUI == 'true' ? inputBoxHeight + this.fileCount * 63 : inputBoxHeight + Math.trunc((this.fileCount + 4) / 5) * 63;
    inputarea.style.height = `${inputBoxHeight}px`;
    this._changeDetectorRef.detectChanges();
  }

  get dynamicHeight() {
    return this.sidebarUI == 'true' ? `${this.fileCount * 50}px` : `${Math.trunc((this.fileCount + 4) / 5) * 50}px`;
  }

  resetHeight() {
    const textarea = this.userInput.nativeElement;
    const inputarea = this.inputbox.nativeElement;
    textarea.style.height = '50px'; // Reset height to auto
    inputarea.style.height = '120px';
  }

  setUpdatedTime(): string {
    const now = new Date();
    return now.toLocaleTimeString([], {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
    });
  }

  getUpdatedTime(chatId = null) {
    if (chatId == null) {
      return this.setUpdatedTime();
    }
    return this.chatHistory[chatId - 2]?.createdTime;
  }

  getLanguageToolTipText() {
    return `Selected language: ${this.selectedLanguage.name}`;
  }

  getUrl(url: string): string {
    return decodeURIComponent(url).split('/').pop()
  }

  showTitle(url: string) {
    return url.length > 20 ? url.substring(0, 20) + '...' : url
  }

  toggleExpand(chatId) {
    this.checkScroll();
    this.checkScrollPosition();
    const chatThoughts = this.chatHistory[chatId - 1].thoughts;
    if (chatThoughts) {
      chatThoughts['show'] = !chatThoughts['show'];
    }
  }

  copyToClipboard(chatId: number) {
    const chatDataList = this.chatHistory[chatId - 1].data;
    let copyMessage = '';
    chatDataList.forEach((chatData) => {
      if (chatData.type === 'table') {
        const tableData = chatData.data;
        if (Array.isArray(tableData) && tableData.length > 0) {
          // Get headers from the first object keys and convert to title case
          const headers = Object.keys(tableData[0]).map(header =>
            header.replace(/\b\w/g, char => char.toUpperCase())
          );
          const headerRow = `| ${headers.join(' | ')} |`;
          const separatorRow = `| ${headers.map(() => '---').join(' | ')} |`;

          // Map the rows to markdown format
          const rows = tableData.map(row =>
            `| ${headers.map(header => row[header.toLowerCase()] || '').join(' | ')} |`
          );

          // Combine header, separator, and rows with a gap of 2 lines between tables
          copyMessage += [headerRow, separatorRow, ...rows].join('\n') + '\n\n';
        } else {
          copyMessage += 'Copy Again\n\n';
        }
      } else if (chatData.type === 'image') {
        const imageUrl = this.getImageLink(chatData.data);
        copyMessage += `${imageUrl}\n\n`;
      } else if (chatData.type === 'plotly') {
        const plot = chatData.data || {};
        const layout = plot.layout || {};
        const traces = plot.data || [];

        const title =
          typeof layout.title === 'string'
            ? layout.title
            : layout.title?.text || 'Chart';

        const xLabel = layout.xaxis?.title?.text || 'X Axis';
        const yLabel = layout.yaxis?.title?.text || 'Y Axis';
        const seriesNames = traces
          .map((t: any, i: number) => t.name || `Series ${i + 1}`)
          .join(', ');

        copyMessage +=
          `Chart Summary:\n` +
          `Title: ${title}\n` +
          `X Axis: ${xLabel}\n` +
          `Y Axis: ${yLabel}\n` +
          `Series: ${seriesNames}\n\n`;

        traces.forEach((trace: any, index: number) => {
          const x = Array.isArray(trace.x) ? trace.x : [];
          const y = Array.isArray(trace.y) ? trace.y : [];
          copyMessage += `Data – ${trace.name || `Series ${index + 1}`}:\n`;
          copyMessage += `X, Y\n`;

          const len = Math.min(x.length, y.length);
          for (let i = 0; i < len; i++) {
            copyMessage += `${x[i]}, ${y[i]}\n`;
          }
          copyMessage += `\n`;
        });
        copyMessage += `\n`;
      } else {
        copyMessage += `${chatData.data}\n\n`;
      }
    });

    let feedBack = this.chatHistory[chatId - 1]?.feedBack;
    feedBack['isCopied'] = !feedBack['isCopied'];
    this.chatHistory[chatId - 1].feedBack = feedBack;
    navigator.clipboard.writeText(copyMessage.trim()).then(() => {
      setTimeout(() => {
        feedBack['isCopied'] = !feedBack['isCopied'];
        this.chatHistory[chatId - 1].feedBack = feedBack;
        this._changeDetectorRef.detectChanges();
      }, 2000);
    }).catch(err => {
      console.error('Failed to copy:', err);
    });
  }

  readChat(chatId: number) {
    // Check if speech synthesis is already speaking
    if (speechSynthesis.speaking) {
      speechSynthesis.cancel();
      let PreviousRunId = localStorage.getItem('readingChatId');
      let runId = this.chatHistory[chatId - 1]?._id;
      if (PreviousRunId && PreviousRunId !== runId) {
        this.chatHistory.find(chat => chat._id === PreviousRunId).feedBack['isReading'] = false;
      }
      else {
        this.chatHistory[chatId - 1].feedBack['isReading'] = false;
        localStorage.removeItem('readingChatId');
        return;
      }
    }
    const chatDataList = this.chatHistory[chatId - 1].data;
    let readMessage = '';
    chatDataList.forEach((chatData) => {
      if (chatData.type === 'table') {
        const tableData = chatData.data;
        if (Array.isArray(tableData) && tableData.length > 0) {
          // Get headers from the first object keys and convert to title case
          const headers = Object.keys(tableData[0]).map(header =>
            header.replace(/\b\w/g, char => char)
          );
          const headerRow = headers.join(', ');
          readMessage += `Table with columns: ${headerRow}. `;

          // Map the rows to a readable format
          tableData.forEach(row => {
            const rowData = headers.map(header => row[header] || '').join(', ');
            readMessage += `Data: ${rowData}. `;
          });
        } else {
          readMessage += 'No data available.';
        }
      } else if (chatData.type === 'image') {
        readMessage += 'Image displayed. ';
      } else if (chatData.type === 'plotly') {
        readMessage += "Plotly chart visualisation displayed."
      } else {
        readMessage += `${chatData.data}. `;
      }
    });

    let feedBack = this.chatHistory[chatId - 1]?.feedBack;
    let runId = this.chatHistory[chatId - 1]?._id;
    feedBack['isReading'] = true;
    this.chatHistory[chatId - 1].feedBack = feedBack;
    const utterance = new SpeechSynthesisUtterance(readMessage);
    utterance.lang = this.selectedLanguage.value;
    localStorage.setItem('readingChatId', runId);

    utterance.onend = () => {
      let feedBack = this.chatHistory[chatId - 1]?.feedBack;
      feedBack['isReading'] = false;
      localStorage.removeItem('readingChatId');
      this.chatHistory[chatId - 1].feedBack = feedBack;
      this._changeDetectorRef.detectChanges();
    };

    speechSynthesis.speak(utterance);
  }

  toggleLike(chatId) {
    this.removeDisliked();
    let feedBack = this.chatHistory[chatId - 1]?.feedBack;
    feedBack['outlinedLikedIcon'] = !feedBack['outlinedLikedIcon']
    if (!feedBack['outlinedLikedIcon']) {
      feedBack['openFeedbackBox'] = false;
      feedBack['outlinedDisLikedIcon'] = true;
      this.chatbotService.sendFeedback(this.chatHistory[chatId - 1]._id, 1, null).subscribe();
    }
    this.chatHistory[chatId - 1].feedBack = feedBack
  }

  removeDisliked() {
    if (this.isDislikePopupOpen) {
      this.isDislikePopupOpen = false;
      let disLikedChatId = localStorage.getItem('disLikedChatId');
      if (disLikedChatId) {
        this.closeFeedback(disLikedChatId);
        localStorage.removeItem('disLikedChatId');
      }
    }
  }

  toggleDislike(chatId) {
    this.removeDisliked();
    let feedBack = this.chatHistory[chatId - 1]?.feedBack;
    feedBack['outlinedDisLikedIcon'] = !feedBack['outlinedDisLikedIcon']
    if (!feedBack['outlinedDisLikedIcon']) {
      feedBack['openFeedbackBox'] = true;
      feedBack['outlinedLikedIcon'] = true;
      feedBack['showTextarea'] = false;
      this.description = null;
      this.isDislikePopupOpen = true;
      localStorage.setItem('disLikedChatId', chatId);
    }
    else {
      feedBack['openFeedbackBox'] = false;
    }
    this.chatHistory[chatId - 1].feedBack = feedBack;
  }

  openImage(imageUrl: string): void {
    this.dialog.open(ChatbotDialogComponent, {
      data: { type: 'image', data: imageUrl },
      panelClass: 'custom-dialog-container'
    });
  }

  getFollowUpResponse(followUp: string) {
    this.userMessage = followUp;
    this.getBotResponse();
  }

  shareChatHistory(chatId: number) {
    let runId = this.chatHistory[chatId - 1]?._id;
    let title = this.chatHistory[chatId - 2]?.text || 'Chat History';
    this.dialog.open(ChatSharePopupComponent, {
      width: '500px',
      panelClass: 'chat-share-dialog',
      data: { runId, title }
    });
  }
}